import type { Step } from "react-joyride";

export const projectFormTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຍິນດີຕ້ອນຮັບສູ່ຟອມໂຄງການ! ທ່ານຈະໄດ້ກຳນົດຊື່ ວັນທີ ຜູ້ຮັບຜິດຊອບ ແລະ ຂັ້ນຕອນໂຄງການ. ທ່ານຈະໄດ້ຮຽນຮູ້ວິທີໃຊ້ງານຟອມນີ້ໃນບົດສອນສັ້ນໆນີ້.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="form-name"]',
    content:
      "ນີ້ແມ່ນຊ່ອງຊື່ໂຄງການ. ກະລຸນາໃສ່ຊື່ທີ່ຊັດເຈນ ເຊັ່ນ 'ໂຄງການປັບປຸງລະບົບ ERP'. ຊ່ອງນີ້ຈຳເປັນຕ້ອງປ້ອນ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="form-description"]',
    content:
      "ນີ້ແມ່ນຊ່ອງຄຳອະທິບາຍ. ທ່ານສາມາດໃສ່ຄຳອະທິບາຍເປົ້າໝາຍ ແລະ ຂອບເຂດໂຄງການ (ບໍ່ບັງຄັບ).",
    placement: "bottom",
  },
  {
    target: '[data-tourid="form-dates"]',
    content:
      "ນີ້ແມ່ນວັນເລີ່ມ ແລະ ວັນສິ້ນສຸດໂຄງການ. ກະລຸນາເລືອກຊ່ອງເວລາດຳເນີນງານໂຄງການ. ວັນສິ້ນສຸດຕ້ອງບໍ່ແມ່ນກ່ອນວັນເລີ່ມ.",
    placement: "left",
  },
  {
    target: '[data-tourid="form-responsible"]',
    content:
      "ນີ້ແມ່ນການເລືອກຜູ້ຮັບຜິດຊອບໂຄງການ. ທ່ານສາມາດຄົ້ນຫາ ແລະ ເລືອກພະນັກງານທີ່ຮັບຜິດຊອບໂຄງການ (ບໍ່ບັງຄັບ).",
    placement: "left",
  },
  {
    target: '[data-tourid="form-phases"]',
    content:
      "ນີ້ແມ່ນຂັ້ນຕອນ ແລະ ຈຸດໝາຍໂຄງການ. ເພີ່ມຂັ້ນຕອນແຕ່ລະໄລຍະ ພ້ອມຊື່ ແລະ ວັນຄວາມຄືບໜ້າ. ສາມາດລາກຈັດລຳດັບ ຫຼື ລຶບຂັ້ນຕອນໄດ້.",
    placement: "top",
  },
  {
    target: '[data-tourid="form-submit"]',
    content:
      "ເມື່ອກຳນົດຂໍ້ມູນແລ້ວ ກົດ 'ບັນທຶກໂຄງການ' ເພື່ອບັນທຶກ ຫຼື 'ຍົກເລີກ' ເພື່ອກັບໄປລາຍການໂຄງການ.",
    placement: "bottom",
  },
];
